import { DIVISION } from "../interfaces";

const divisionCategoryNameMap = new Map<DIVISION, string>([
	[DIVISION.CARGO_BRANCH, "Відділення"],
	[DIVISION.POST_BRANCH, "Відділення"],
	[DIVISION.POSTOMAT, "Поштомат"],
	[DIVISION.PUDO, "Пункт"]
]);

export const divisionCategoryToName = (divisionCategory: DIVISION): string =>
	divisionCategoryNameMap.get(divisionCategory);
